import React from 'react';
import ReactDOM from 'react-dom';

const ROOT_ID = 'modal-root';

export const ModalRoot = () => {
  return <div id={ROOT_ID} />;
};

export const ModalPortal: React.FC = (props) => {
  const { children } = props;

  const modalRoot = document.getElementById(ROOT_ID);

  if (modalRoot) {
    return ReactDOM.createPortal(children, modalRoot);
  }

  return null;
};
